<template>
  <div class="tab">
      <ul>
          <li :class="{current: isLogos}"><router-link to="/downloads/logos">ロゴ</router-link></li>
          <li :class="{current: isZoom}"><router-link to="/downloads/zoom">ZOOM背景</router-link></li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: ['isLogos', 'isZoom']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab {
    width: 100%;
}

ul {
    display: flex;
    width: 100%;
    border-radius: 1.2rem;
    overflow: hidden;
}
li {
    flex: 1;
}
a {
  text-decoration: none;
  display: block;
  padding: 0 2.4rem;
  background: var(--honeydew);
  font-size: var(--large-font-size);
  line-height: 3.55555555556;
  color: var(--novasell-green);
  font-weight: var(--bold-font-weight);
  text-align: center;
  transition: 0.5s;
}

a:hover {
  background: var(--novasell-green);
  color: var(--white);
  transition: 0.1s;
}

li.current a {
   background: var(--novasell-green);
   color: var(--white);
   transition: 0.5s;
}

li.current a:hover {
    background: var(--dark-green);
    transition: 0.1s;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/Tab.vue